import React from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';

const SubscriptionExpired = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="h-8 w-8 text-red-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-center mb-4">
          Assinatura Expirada
        </h1>

        <p className="text-slate-600 text-center mb-8">
          Sua assinatura do ImóvelIA expirou. Renove agora para continuar tendo acesso a todas as funcionalidades.
        </p>

        <a
          href="https://pay.kiwify.com.br/cSvs3ux"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors text-center flex items-center justify-center gap-2"
        >
          Renovar Assinatura
          <ArrowRight className="h-5 w-5" />
        </a>
      </div>
    </div>
  );
};

export default SubscriptionExpired;